import React, {useState} from "react";
import {Container, Image} from "../../../components";
import FilterSearch from "../../../components/filters/FilterSearch";
import styles from "./FAQ.module.scss";
import AllQuestions from "./AllQuestions/AllQuestions";
import arrow from 'assets/images/svg/arrow-look-right-green.svg';
import {InputPosition} from "../../../components/filters/FilterSearch/FilterSearch";

const QUESTION_THEMES = {
  GENERAL: "GENERAL",
  PROJECTS: "PROJECTS",
  LOANS: "LOANS",
  INVESTORS: "INVESTORS",
  BORROWERS: "BORROWERS"
} as const;

type ObjectValues<T> = T[keyof T];
type QuestionTheme = ObjectValues<typeof QUESTION_THEMES>;

const questionLinks = [
  {
    id: QUESTION_THEMES.GENERAL,
    label: "Общие вопросы",
    href: "#general",
  },
  {
    id: QUESTION_THEMES.INVESTORS,
    label: "Инвесторам",
    href: "#investors",
  },
  {
    id: QUESTION_THEMES.BORROWERS,
    label: "Заемщикам",
    href: "#borrowers",
  },
];

const FAQ = () => {
  const [currentTheme, setCurrentTheme] = useState<QuestionTheme>(QUESTION_THEMES.GENERAL);
  const [search, setSearch] = useState('');

  return (
    <Container>
      <div className={styles.searchContainer}>
        <FilterSearch className={styles.searchInput} search={search} position={InputPosition.RIGHT} onSearchChange={setSearch}/>
      </div>
      <div className={styles.questionsContainer}>
        <div className={styles.commonQuestions}>
          {questionLinks.map(({id, label, href}) => (
            <a
              href={href}
              className={styles.commonQuestions__link}
              aria-current={currentTheme === id}
              onClick={() => setCurrentTheme(id)}
              key={id}
            >
              {label}
              {currentTheme === id && <Image className={styles.arrow} src={arrow} alt="->" />}
            </a>
          ))}
        </div>
        <div className={styles.allQuestions}><AllQuestions search={search}/></div>
      </div>
    </Container>
  );
};

export default FAQ;